import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useToasts } from "app/pages/activation/hooks/helpers/useToasts";
import { translate } from "app/filters/i18nFilter";
import { ACTIVATION_METADATA } from "app/pages/activation/queries/data/useActivationMetadataQuery";
import { ACTIVATION_OBJECTS_QUERY_KEY } from "app/pages/activation/queries/data/useActivationSetListQuery";
import { SHORT_ACTIVATION_OBJECTS_QUERY_KEY } from "app/pages/activation/queries/data/useShortActivationSetListQuery";
import { createActivationApi } from "app/pages/activation/services/api";
import type { ActivationObjectSchema, CreateActivationParams } from "app/pages/activation/types/api";

import { ACTIVATION_OBJECT_QUERY_KEY } from "./useActivationObjectQuery";

export const useCreateActivationObjectMutation = () => {
    const { showErrorToast } = useToasts();
    const queryClient = useQueryClient();

    return useMutation<ActivationObjectSchema, Error, unknown>({
        mutationFn: (params: CreateActivationParams) => {
            const api = createActivationApi();

            return api.activation.create(params);
        },
        onSuccess(data) {
            queryClient.setQueryData([ACTIVATION_OBJECT_QUERY_KEY, data.id], data);
            void queryClient.invalidateQueries({ queryKey: [SHORT_ACTIVATION_OBJECTS_QUERY_KEY] });
            void queryClient.invalidateQueries({ queryKey: [ACTIVATION_OBJECTS_QUERY_KEY] });
            void queryClient.invalidateQueries({ queryKey: [ACTIVATION_METADATA] });
        },
        onError: () => {
            showErrorToast(translate("activation.setup.create_activation_object_error"));
        },
    });
};
